// Slide model based on API::V1::GlobalSlideActivityResultSerializer
export default {

  // Relationships
  slide: {
    jsonApi: 'hasOne',
    type: 'global_slides'
  },

  activity: {
    jsonApi: 'hasOne',
    type: 'activities'
  },

  // Attributes
  status: null,
  event: null,
  results: {},
  updated_at: null
}
